import {
  field,
  json,
  lazy,
  relation,
  text,
} from "@nozbe/watermelondb/decorators";
import {
  ProductLocationInventoryPricing,
  ProductOption,
  SelectedOption,
} from "@towersystems/roam-common/lib/generated-types";
import { noopSanitizeJSON } from "../utils";
import { BaseModel } from "./Base";
import { Q, Relation } from "@nozbe/watermelondb";
import Category from "./Category";
import Department from "./Department";
import Supplier from "./Supplier";
import ProductKit from "./ProductKit";

export const SanitizeJSONLocationPricing = (json: any) => {
  return json;
};

export default class Product extends BaseModel {
  static table = "products";
  @relation("categories", "category_id") category: Relation<Category>;
  @relation("departments", "department_id") department: Relation<Department>;
  @relation("suppliers", "supplier_id") supplier: Relation<Supplier>;
  @relation("product_kits", "product_kit_id") productKit: Relation<ProductKit>;

  @text("name") name: string;
  @text("image_url") imageUrl?: string;
  @field("taxable") taxable: boolean;
  @field("internal") internal: boolean;
  @field("serial_numbers_arr") serialNumbersArr: boolean;
  @field("serial_numbers_sale") serialNumbersSale: boolean;

  @text("description") description: string | null;
  @text("web_description") webDescription: string | null;
  @text("price_lookup") priceLookup: string | null;
  @field("weight") weight: number | null;
  @text("uom") UOM: string | null;
  @field("web_price") webPrice: number | null;
  @text("supplier_stock_code") supplierStockCode: string | null;

  @text("stock_code")
  stockCode: string | null;
  @text("stock_number") stockNumber: string;
  @text("variant_parent_id") variantParentId: string | null;
  @json("location_inventory_pricing", SanitizeJSONLocationPricing)
  locationInventoryPricing: ProductLocationInventoryPricing[];
  @field("total_inventory") totalInventory: number;
  @field("has_variants") hasVariants: boolean;
  @text("display_name") displayName: string;
  @field("total_variants") totalVariants: number;

  @json("options", noopSanitizeJSON) options: ProductOption[];
  @json("selected_options", noopSanitizeJSON) selectedOptions: SelectedOption[];
  @json("tags", noopSanitizeJSON) tags: string[] | null;

  @field("discountable") discountable: boolean;

  @field("loyalty_point_redeem_value") loyaltyPointRedeemValue: number;
  @field("loyalty_point_earn_value") loyaltyPointEarnValue: number;

  @field("active") active: boolean;
  @field("adjustable") adjustable: boolean;

  // the main product is also a variant
  @lazy variantProducts = this.collections
    .get<Product>("products")
    .query(Q.or(Q.where("variant_parent_id", this.id), Q.where("id", this.id)));

  get isKit() {
    return this._getRaw("product_kit_id") !== null;
  }

  get isGiftCard() {
    return this.stockCode === "GIFTCARD";
  }
}
